<template>
  <div :class="['float-menu', { 'toggle-sidebar': isShow }]">
    <router-link
      :to="dashboardPage"
      active-class="selected-panel"
      @click.native="closeSideMenu"
    >
      <div class="page-container">
        <div class="page-icon dashboard-header" />
        <div class="page-label">
          <div>{{ $t('COMMON.str04') }}</div>
        </div>
      </div>
    </router-link>
        <router-link
      to="/studio"
      active-class="selected-panel"
      @click.native="closeSideMenu"
    >
      <div class="page-container">
        <div class="page-icon studio-header" />
        <div class="page-label">
          <div>{{ $t('STUDIO.sollaeStudio') }}</div>
        </div>
      </div>
    </router-link>
    <router-link
      :to="managementPage"
      active-class="selected-panel"
      @click.native="closeSideMenu"
    >
      <div class="page-container">
        <div class="page-icon management-header" />
        <div class="page-label">
          <div>{{ $t('COMMON.str10') }}</div>
        </div>
      </div>
    </router-link>
    <div class="sub-layout">
      <router-link :to="managementPage" @click.native="closeSideMenu">
        <div :class="['level-1-page', { 'selected-section': !isUserPref }]">
          {{ $t('COMMON.str37') }}
        </div> </router-link
      ><router-link :to="preferencePage" @click.native="closeSideMenu">
        <div :class="['level-1-page', { 'selected-section': isUserPref }]">
          {{ $t('COMMON.str38') }}
        </div>
      </router-link>
    </div>
    <a :href="$t('LINKS.str01')" target="_blank">
      <div class="page-container">
        <div class="page-icon documentation-header" />
        <div class="page-label">
          <div>{{ $t('COMMON.str09') }}</div>
        </div>
      </div>
    </a>
    <router-link
      to="/testrequest"
      active-class="selected-panel"
      @click.native="closeSideMenu"
      v-if="enabledTest"
    >
      <div class="page-container">
        <div class="page-icon studio-header" />
        <div class="page-label">
          <div>Test Request</div>
        </div>
      </div>
    </router-link>
    <!--<router-link
      to="/modbus"
      active-class="selected-panel"
      @click.native="closeSideMenu"
    >
      <div class="page-container">
        <div class="page-icon studio-header" />
        <div class="page-label">
          <div>Modbus</div>
        </div>
      </div>
    </router-link>-->
    <!--<a
      href="/serverapi"
    >
      <div class="page-container">
        <div class="page-label">
          ---Server Test---
        </div>
      </div>
    </a>-->
  </div>
</template>
<script>
export default {
  name: 'SideMenu',
  props: {
    isShow: Boolean,
  },
  created() {
    this.dashboardPage = '/dashboard';
    this.managementPage = '/management';
    this.preferencePage = '/management/pref';
    this.enabledTest = process.env.ENABLE_TEST;
  },
  computed: {
    isUserPref() {
      return this.$route.path === this.preferencePage;
    },
  },
  methods: {
    closeSideMenu() {
      this.$emit('close-sidebar');
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.sub-layout {
  display: none;
  position: relative;
  padding: 10px 15px;
  width: 190px;
  color: #949494;
  background-color: #252932;
}

.selected-panel + .sub-layout {
  display: block;
}

.sub-layout::before {
  content: '';
  position: absolute;
  width: 0.4em;
  height: 0.4em;
  border: solid #ff6000;
  border-width: 0 0.15em 0.15em 0;
  transform: rotate(45deg);
  left: 185px;
  top: -33px;
}

.sub-layout > div {
  text-align: left;
  height: auto;
  line-height: 1.5;
}

.level-1-page {
  font-size: 12.5px;
  padding: 5px 10px 5px 50px;
  position: relative;
  cursor: pointer;
  display: block;
  text-decoration: none;
  color: #949494;
}

.level-2-page {
  font-size: 0.75em;
  padding: 5px 5px 5px 25px;
}

.selected-section {
  color: #ff6000;
  position: relative;
}

.page-container {
  width: 195px;
  color: #868686;
  padding: 16px 0 16px 25px;
  font-size: 15px;
  text-transform: capitalize;
  display: flex;
  align-items: center;
  cursor: pointer;
  justify-content: center;
}

.page-label {
  width: 155px;
  height: 23px;
  position: relative;
}

.page-label > div {
  position: absolute;
  top: 50%;
  left: 0;
  transform: translate(0, -50%);
}

.page-container:hover {
  background-color: #ff6000;
  color: #262626;
}

.page-icon {
  width: 23px;
  height: 23px;
  margin: 0 11.5px 0 5.5px;
  background-position: center;
  background-size: contain;
}

.selected-panel .page-icon {
  background-color: #262626;
}

.dashboard-header {
  background-image: url(~@/assets/img/icon_dashboard.png);
}

.page-container:hover .dashboard-header {
  background-image: url(~@/assets/img/icon_dashboard_hover.png);
}

.selected-panel .dashboard-header {
  background-image: url(~@/assets/img/icon_dashboard_selected.png);
}

.management-header {
  background-image: url(~@/assets/img/icon_management.png);
}

.page-container:hover .management-header {
  background-image: url(~@/assets/img/icon_management_hover.png);
}

.selected-panel .management-header {
  background-image: url(~@/assets/img/icon_management_selected.png);
}

.documentation-header {
  background-image: url(~@/assets/img/icon_documentation.png);
}

.page-container:hover .documentation-header {
  background-image: url(~@/assets/img/icon_documentation_hover.png);
}

.selected-panel .documentation-header {
  background-image: url(~@/assets/img/icon_documentation_selected.png);
}

.studio-header {
  background-image: url(~@/assets/img/icon_studio.png);
}

.page-container:hover .studio-header {
  background-image: url(~@/assets/img/icon_studio_hover.png);
}

.selected-panel .studio-header {
  background-image: url(~@/assets/img/icon_studio_selected.png);
}

.float-menu {
  position: fixed;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 2;
  color: #ffffff;
  background-color: #333740;
  padding-top: 80px;
  transition: 0.2s ease-in-out;
  font-family: Work Sans, Nunito, sans-serif;
}

.selected-panel {
  pointer-events: none;
  cursor: default;
}

.selected-panel .page-container {
  color: #ff6000;
  background-color: #262626;
}

@media screen and (max-width: 799px) {
  .float-menu:not(.toggle-sidebar) {
    left: -280px;
  }
}
</style>
